import {GiEarthAfricaEurope} from 'react-icons/gi'
import {AiFillCar} from 'react-icons/ai'
import {MdFamilyRestroom} from 'react-icons/md'
import {BiBuildingHouse} from 'react-icons/bi'
import ProgramItem from '../pages/ProgramItem'


const Uzhnu_driving_school = {
    title:"Driving_School",
    image:"https://profkom-bucket.s3.amazonaws.com/photo_5456496104502836261_x.jpg",
    textUA:<p>          
                До уваги майбутніх водіїв! Запрошуємо на  курси підготовки водіїв<br/>
                Автомобільна школа ДВНЗ "УжНУ" проводить підготовку водіїв категорії «В». 
                Навчатись на курсах автомобільної підготовки ДВНЗ "УжНУ" можуть усі бажаючі.<br/>
            
                <ul>
                    На курсах автомобільної підготовки слухачі вивчають такі дисципліни: 
                    <li> правила дорожнього руху; </li>
                    <li> основи керування автомобілем та безпека дорожнього руху;  </li>
                    <li> будова та основи технічного обслуговування автомобіля;  </li>
                    <li> медичне забезпечення безпеки дорожнього руху (перша допомога); </li>
                    <li> практичне керування автомобілем.  </li>
                </ul>
                Термін навчання складає 10 тижнів.
            
                Теоретичні заняття проходять з 18:00 до 20:00 години. 
                Вартість  навчання: 6 800 грн
                (для студентів та співробітників університету 6500 грн.).<br/>
            
                Інструктори та викладачі автомобільної школи є сертифікованими спеціалістами. 
                Це професіонали своєї справи і в той самий час - молода та перспективна команда, 
                яка використовує класичні та сучасні методи навчання.<br/>

                Для підготовки водіїв наша Автошкола забезпечена  навчальними автомобілями, 
                які мають чудові технічні характеристики, що забезпечують безпечну, комфортну їзду.<br/>
                Адреса: м. Ужгород, вул. Капітульна 26</p>,
    
    textEN:<p>          
                Attention future drivers! We invite you to driver training courses<br/>
                The driving school of the UzhNU State Higher Secondary School conducts the training of category "B" drivers. 
                Anyone can study at the automotive training courses of the UzhNU.<br/>
                
                <ul>
                    At automotive training courses, students study the following disciplines: 
                    <li> traffic rules; </li>
                    <li> basics of driving a car and road safety;</li>
                    <li> structure and basics of car maintenance;</li>
                    <li> medical provision of road traffic safety (first aid);</li>
                    <li> practical driving.</li>
                </ul>
            
                The training period is 10 weeks.
                
                Theoretical classes are held from 18:00 to 20:00. 
                Tuition fee: 6,800 UAH 
                (6,500 UAH for students and employees of the university).<br/>

                Driving school instructors and teachers are certified specialists.
                They are professionals in their field and at the same time - a young and promising team,
                which uses classical and modern teaching methods.<br/>

                For driver training, our Driving School is equipped with training cars,
                which have excellent technical characteristics that ensure a safe, comfortable ride.<br/>

                Address: Uzhgorod, str. Kapitulna 26</p>
}

const Orphans_program = {
    title:"Program_for_orphans",
    image:"https://profkom-bucket.s3.amazonaws.com/orphans-students.jpg",
    textUA:<p>          
                Відповідно до Постанови Кабінету Міністрів України №226 від 05.04.1994р. «Про поліпшення виховання, навчання,
                соціального захисту та матеріального забезпечення дітей-сиріт і дітей, позбавлених батьківського піклування» та
                Постанови Кабінету Міністрів України №1591 від 22.11.2004 р. «Про затвердження норм харчування у навчальних та
                оздоровчих закладах» в Ужгородському національному університеті діє програма для дітей сиріт і дітей, позбавлених
                батьківського піклування за якою студенти отримують щомісячні нарахування на харчування та щорічні виплати на літературу
                та обмудирування.<br/>
                
                Виплати можуть отримувати студенти, які навчаються за державним замовленням.<br/>
                Виплати на літературу та обмудирування отримують тільки студенти, які перебувають на повному державному замовленні 
                (повнолітні та не мають опікуна).<br/>
                
                Виплати на харчування в розмірі 110 грн. на день отримують студенти, які перебувають на повному державному замовленні. Студенти, 
                які перебувають на неповному державному утриманні (мають опікуна) отримують 40% від вищевказаної суми (44 грн. на день)<br/>

                <ul className='mt-4'>
                Для оформлення виплат потрібно:
                    <li>копію паспорта;</li>
                    <li>копію ідентифікаційного коду;</li>
                    <li>витяг з обліково-статистичної картки дитини сироти та дитини позбавленої батьківського піклування;</li>
                    <li>довідка про реєстрацію місця проживання;</li>
                    <li>свідоцтво про народження;</li>
                    <li>розпорядження про надання дитині статусу дитина-сирота/дитина позбавлена батьківського піклування;</li>
                    <li>розпорядження або рішення суду про встановлення опіки (або призначення у будинок сімейного типу);</li>
                    <li>свідоцтво про смерть/рішення про позбавлення батьківських прав/рішення про призначення недієздатним;</li>
                    <li>написати заяву (зразок буде вказано нижче, формат А4);</li>
                    <li>всі необхідні документи та заяву потрібно принести в приміщення профспілкової організації за адресою: Університетська 12 (3 поверх);</li>
                </ul>

                <p className='text-center mt-3'>
                    <a 
                        style={{textDecoration:"none", color:"grey"}}
                        href='https://profkom-bucket.s3.amazonaws.com/%D0%B7%D1%80%D0%B0%D0%B7%D0%BE%D0%BA-%D0%B7%D0%B0%D1%8F%D0%B2%D0%B0-%D0%BD%D0%B0-%D0%BF%D0%BE%D0%B2%D0%BD%D0%B5.pdf'
                    >
                        Зразок заяви на прийняття на повне державне утримання
                    </a>
                <br/>
                    <a 
                        className='mt-3'
                        style={{textDecoration:"none", color:"grey"}}
                        href='https://profkom-bucket.s3.amazonaws.com/%D0%B7%D1%80%D0%B0%D0%B7%D0%BE%D0%BA-%D0%B7%D0%B0%D1%8F%D0%B2%D0%B0-%D0%BD%D0%B0-%D0%BD%D0%B5%D0%BF%D0%BE%D0%B2%D0%BD%D0%B5.pdf'
                    >
                        Зразок заяви на прийняття на неповне державне утримання
                    </a>
                </p>
           </p>,
    
    textEN:<p>          
                In accordance with the Resolution of the Cabinet of Ministers of Ukraine No. 226 of April 5, 1994. "On improving
                education, training, social protection and material support of orphans and children deprived of parental care" and
                Resolution of the Cabinet of Ministers of Ukraine No. 1591 dated November 22, 2004 "On approval of nutrition standards
                in educational and recreational institutions" at the Uzhhorod National University, there is a program for orphans and 
                children deprived of their parents care under which students receive monthly allowances for food and annual allowances
                for literature and clothing.<br/>
                
                Payments can be received by students studying under the state order.<br/>
                Payments for literature and uniforms are received only by students who are on a full state contract
                (of legal age and without a guardian).<br/>
                Food payments in the amount of 110 UAH per day are received by students who are on a full state contract. Students,
                who are partially dependent on the state (have a guardian) receive 40% of the above amount (44 UAH per day)<br/>

                <ul className='mt-4'>
                To process payments, you need:
                    <li>a copy of the passport;</li>
                    <li>a copy of the identification code;</li>
                    <li>an extract from the accounting and statistical card of an orphan child and a child deprived of parental care;</li>
                    <li>certificate of residence registration;</li>
                    <li>Birth Certificate;</li>
                    <li>an order granting the child the status of an orphan/child deprived of parental care;</li>
                    <li>a court order or decision to establish guardianship (or placement in a family-type home);</li>
                    <li>death certificate/decision on deprivation of parental rights/decision on appointment as incapacitated;</li>
                    <li>write a statement (a sample will be provided below, A4 format);</li>
                    <li>all the necessary documents and the application must be brought to the premises of the trade union organization
                         at the address: Universitetska 12 (3rd floor);</li>
                </ul>

                <p className='text-center mt-3'>
                    <a 
                        style={{textDecoration:"none", color:"grey"}}
                        href='https://profkom-bucket.s3.amazonaws.com/%D0%B7%D1%80%D0%B0%D0%B7%D0%BE%D0%BA-%D0%B7%D0%B0%D1%8F%D0%B2%D0%B0-%D0%BD%D0%B0-%D0%BF%D0%BE%D0%B2%D0%BD%D0%B5.pdf'
                    >
                        Sample application for admission to full state maintenance
                    </a>
                    <br/>
                    <a 
                        className='mt-3'
                        style={{textDecoration:"none", color:"grey"}}
                        href='https://profkom-bucket.s3.amazonaws.com/%D0%B7%D1%80%D0%B0%D0%B7%D0%BE%D0%BA-%D0%B7%D0%B0%D1%8F%D0%B2%D0%B0-%D0%BD%D0%B0-%D0%BD%D0%B5%D0%BF%D0%BE%D0%B2%D0%BD%D0%B5.pdf'
                    >
                        Sample application for acceptance for partial state maintenance
                    </a>
                </p>
        </p>
}

const Disabled_people_program = {
    title:"Program_for_disabled",
    image:"https://profkom-bucket.s3.amazonaws.com/disabled-students.png",
    textUA:<p>          
            Згідно з колективним договором між Ужгородським національним університетом та Первинною профспілковою організацією 
            студентів УжНУ, університет надає знижку 50% на проживання в гуртожитках університету інвалідам 1 та 2 груп та інвалідам дитистава.<br/>
            Оформленням документів займається Студентська профспілкова організація<br/>

                <ul className='mt-4'>
                Для отримання знижки потрібно:
                    <li>копію паспорта;</li>
                    <li>копію ідентифікаційного коду;</li>
                    <li>копію медичної довідки або посвідчення;</li>
                    <li>написати заяву (зразок буде вказано нижче, формат А4);</li>
                    <li>всі необхідні документи та заяву потрібно принести в приміщення профспілкової організації за адресою: Університетська 12 (3 поверх);</li>
                </ul>

                <p className='text-center mt-3 '>
                    <a 
                        style={{textDecoration:"none", color:"grey"}}
                        href='https://profkom-bucket.s3.amazonaws.com/%D0%B7%D1%80%D0%B0%D0%B7%D0%BE%D0%BA-%D0%B7%D0%B0%D1%8F%D0%B2%D0%B8-%D1%96%D0%BD%D0%B2%D0%B0%D0%BB%D1%96%D0%B4%D0%B8+(1).pdf'
                    >
                        Зразок заяви
                    </a>
                </p>
           </p>,
    
    textEN:<p>          
                According to the collective agreement between Uzhgorod National University and the Primary Trade Union Organization
                students of UzhNU, the university provides a 50% discount on accommodation in the university dormitories for disabled
                people of groups 1 and 2 and children with disabilities.<br/>
                The Student Trade Union Organization handles the preparation of documents<br/>

                    <ul className='mt-4'>
                    To receive a discount, you need:
                        <li>a copy of the passport;</li>
                        <li>a copy of the identification code;</li>
                        <li>a copy of a medical certificate;</li>
                        <li>write a statement (a sample will be provided below, A4 format);</li>
                        <li>all necessary documents and statement must be brought to the premises of the trade union organization
                             at the address: Universytetska 12 (3rd floor);
                        </li>
                    </ul>

                    <p className='text-center mt-3 '>
                        <a 
                            style={{textDecoration:"none", color:"grey"}}
                            href='https://profkom-bucket.s3.amazonaws.com/%D0%B7%D1%80%D0%B0%D0%B7%D0%BE%D0%BA-%D0%B7%D0%B0%D1%8F%D0%B2%D0%B8-%D1%96%D0%BD%D0%B2%D0%B0%D0%BB%D1%96%D0%B4%D0%B8+(1).pdf'
                        >
                           Sample statement
                        </a>
                    </p>
            </p>
}

const ISIC_program = {
    title:"ISIC",
    image:"https://profkom-bucket.s3.amazonaws.com/isic-logo-color.png",
    textUA:<p>          
            ISIC — International Student Identity Card (Міжнародне посвідчення особи і статусу студента).<br/>
            ISIC створене Міжнародною Конфедерацією Студентського Туризму (ISTC) в 1956 році під егідою UNESCO,
            яке має мету — підтримувати співдружність активних, допитливих, відповідальних студентів.<br/>
            ISIC надасть вам 150 000 знижок у всьому світі на перельоти, екскурсії та шопінг у 130 країнах!<br/>
            
            ISIC доступний для оформлення учням з 12-ти років та студентам очної форми навчання. При замовленні з 25 серпня
            має найдовший термін дії, а саме 16 місяців (09/2022-12/2023), який друкується на пластиковому варіанті картки, 
            незалежно від дати оформлення.<br/>

            <p className='text-center mt-3'>Що таке ISIC?</p>

            МІЖНАРОДНИЙ КВИТОК ISIC – це єдине визнане міжнародне посвідчення, яке підтверджує статус учня/студента в усьому світі 
            та відкриває для тебе світ знижок та привілеїв, акцій та спеціальних пропозицій.<br/>

            ЗНИЖКИ ТА АКЦІЇ. Знижки на авіаперельоти, проживання в готелях і хостелах. Відвідування зі знижками кінотеатрів, аквапарків,
            закладів культури, центрів розваг і клубів. Знижки в кафе, ресторанах і барах.<br/>

            ОСОБЛИВІ ПРИВІЛЕЇ.
            Привілеї на додаткову освіту, мовні курси, тренінги та майстер-класи. Знижки на покупку турів, страхування і навчання за
            кордоном. Безкоштовний вхід у музеї, театри і культурні центри світу.<br/>

            BE LIKE ISIC. Бути як ISIC – це бути в курсі подій, відвідувати цікаві та корисні заходи, вміти відпочивати та веселитися,
            смачно їсти, займатися спортом, подорожувати, займатися самоосвітою та розвиватися.<br/>

            <ul className='mt-4'>
            Для оформлення ISIC необхідно надати:
                <li> документ (необхідно взяти оригінал та його копію), який підтверджує статус студента денної форми навчання на момент оформлення ISIC;</li>
                <li>документ, який засвідчує вашу особу та дату народження документ, який містить дату народження (паспорт внутрішній або закордонний громадянина України, 
                    свідоцтво про народження, посвідчення водія на право керувати транспортними засобами;
                </li>
                <li>дві фотографії формату 3х4;</li>
            </ul>
        </p>,
    
    textEN:<p>          
            ISIC — International Student Identity Card.<br/>
            ISIC was created by the International Confederation of Student Tourism in 1956 under the auspices of UNESCO,
            which aims to support a community of active, inquisitive, responsible students.<br/>
            ISIC will give you 150,000 discounts worldwide on flights, excursions and shopping in 130 countries!<br/>
            
            ISIC is available for students from the age of 12 and full-time students. When ordering from August 25
            has the longest term of validity, namely 16 months (09/2022-12/2023), which is printed on the plastic version of the card,
            regardless of the date of registration.<br/>

            <p className='text-center mt-3'>What is ISIC??</p>

            ISIC INTERNATIONAL TICKET is the only recognized international document that confirms the status of a pupil/student worldwide
            and opens for you the world of discounts and privileges, promotions and special offers.<br/>

            DISCOUNTS AND PROMOTIONS. Discounts on flights, accommodation in hotels and hostels. Discounted visits to cinemas, water parks,
            cultural institutions, entertainment centers and clubs. Discounts in cafes, restaurants and bars.<br/>

            SPECIAL PRIVILEGES.
            Privileges for additional education, language courses, trainings and master classes. Discounts on the purchase of tours, insurance and training for
            the border Free entry to museums, theaters and cultural centers of the world.<br/>

            BE LIKE ISIC. To be like ISIC is to be aware of events, to attend interesting and useful events, to be able to relax and have fun,
            eat well, exercise, travel, self-educate and develop.<br/>

            <ul className='mt-4'>
            To issue an ISIC, you must provide:
                <li> a document (it is necessary to take the original and its copy) confirming the status of a full-time student at the time of issuing the ISIC;</li>
                <li>a document that certifies your identity and date of birth a document that contains the date of birth (passport of an internal or foreign citizen of Ukraine,
                    birth certificate, driver's license for the right to drive vehicles;
                </li>
                <li>two 3x4 photos;</li>
            </ul>
        </p>
}

export const programs = [
    {
        id:1,
        title: Uzhnu_driving_school.title,
        icon:<AiFillCar size={70}/>,
        content:<ProgramItem
                    title={Uzhnu_driving_school.title}
                    image={Uzhnu_driving_school.image}
                    textUA={Uzhnu_driving_school.textUA}
                    textEN={Uzhnu_driving_school.textEN}
                />
    },

    {
        id:2,
        title: Orphans_program.title,
        icon:<MdFamilyRestroom size={70}/>,
        content:<ProgramItem
                    title={Orphans_program.title}
                    image={Orphans_program.image}
                    textUA={Orphans_program.textUA}
                    textEN={Orphans_program.textEN}
                />
    },

    {
        id:3,
        title: Disabled_people_program.title,
        icon:<BiBuildingHouse size={70}/>,
        content:<ProgramItem
                    title={Disabled_people_program.title}
                    image={Disabled_people_program.image}
                    textUA={Disabled_people_program.textUA}
                    textEN={Disabled_people_program.textEN}
                />
    },

    {
        id:4,
        title: ISIC_program.title,
        icon:<GiEarthAfricaEurope size={70}/>,
        content:<ProgramItem
                    title={ISIC_program.title}
                    image={ISIC_program.image}
                    textUA={ISIC_program.textUA}
                    textEN={ISIC_program.textEN}
                />
    }
]